let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("tdXqH"), load("hTb1M"), load("iZycL"), load("bLHOz"), load("82QsP"), load("an2zh")]).then(() => parcelRequire('3Fqft'));